export const PaymentStatus = {
    PENDING: "PENDING",
    PAID: "PAID",
    CANCELED: "CANCELED"
}